import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { MyEInvoiceRequestRejectionContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_my_einvoice_request_rejection_internal_doc_hdr_container.model';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { ApiResponseModel, ApiVisa } from '../shared';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class MyEInvoiceRequestRejectionService extends BaseApiPublicLoginTemplateService<MyEInvoiceRequestRejectionContainerModel, MyEInvoiceRequestRejectionContainerModel, MyEInvoiceRequestRejectionContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-rejections/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-rejections/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-rejections/backoffice-ep'
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-rejections/'+ BaseApiTemplateService.LOGIN_ENTITY_EP
    this.httpClient = http;
  }

  processRejectionRequests(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<MyEInvoiceRequestRejectionContainerModel>> {
    let customUrl;
    let endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-rejections/submit-to-lhdn/backoffice-ep'
    if (visa.api_domain_url) {
      customUrl = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<MyEInvoiceRequestRejectionContainerModel>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}
